(() => {
  const badgeValues={none:'None',blue:'Standard UK — Blue',ev:'Standard UK — Green (EV)',raised_blue:'4D UK — Blue',raised_ev:'4D UK — Green (EV)'};
  const defaults={vehicle:'car',position:'pair',style:'2d',finish:'gloss',thickness:'3',border:'none',badge:'none'};
  const allowed={vehicle:['car','motorcycle'],position:['front','rear','pair'],style:['2d','4d'],finish:['gloss','matte'],thickness:['3','5','6'],border:['none','black'],badge:Object.keys(badgeValues)};
  const normalizeReg=value=>String(value).trim().replace(/\s+/g,' ').toUpperCase();
  const validReg=value=>{const reg=normalizeReg(value),compact=reg.replace(/ /g,'');return /^[A-Z0-9 ]+$/.test(reg)&&compact.length<=7&&/[A-Z]/.test(compact)&&/\d/.test(compact);};
  function normalizeState(input){
    const state={...defaults};
    Object.keys(allowed).forEach(key=>{if(allowed[key].includes(input[key]))state[key]=input[key];});
    if(state.vehicle==='motorcycle')state.position='rear';
    if(state.finish==='matte'&&state.thickness==='6')state.thickness='3';
    return state;
  }
  function disabled(state,key,value){
    return (key==='position'&&state.vehicle==='motorcycle'&&value!=='rear')||
      (['finish','thickness'].includes(key)&&state.style==='2d')||
      (key==='finish'&&value==='matte'&&state.thickness==='6')||
      (key==='thickness'&&value==='6'&&state.finish==='matte');
  }
  function specification(state){
    const s=normalizeState(state),badge=badgeValues[s.badge];
    if(s.vehicle==='motorcycle')return {key:'motorcycle_'+s.style,options:s.style==='2d'?[badge]:[s.thickness+' mm',s.finish==='gloss'?'Gloss black':'Matte black',badge]};
    if(s.position!=='pair')return {key:'car_single',options:[s.position==='front'?'Front — White':'Rear — Yellow',s.style==='2d'?'Standard 2D — Flat printed':'4D — '+s.thickness+' mm '+s.finish+' black',badge]};
    return {key:'car_'+s.style,options:s.style==='2d'?['520 × 111 mm — Front & rear pair',badge]:[s.thickness+' mm',s.finish==='gloss'?'Gloss black':'Matte black',badge]};
  }
  function resolve(state,products){
    const spec=specification(state),product=products[spec.key];
    return {product,variant:product?.variants.find(v=>spec.options.length===v.options.length&&spec.options.every((x,i)=>x===v.options[i]))};
  }
  function price(state,products,quantity,taxesIncluded){
    const selected=resolve(state,products),base=resolve({...state,badge:'none'},products);
    if(!selected.variant||!base.variant||!Number.isInteger(quantity)||quantity<1||quantity>99)return null;
    const gross=v=>selected.product.live&&taxesIncluded?Number(v.price):Math.round(Number(v.price)*1.2);
    const itemGross=gross(selected.variant)*quantity,baseGross=gross(base.variant)*quantity;
    const delivery=state.vehicle==='car'?700:300;
    return {base:baseGross,badge:itemGross-baseGross,items:itemGross,delivery,total:itemGross+delivery,net:Math.round((itemGross+delivery)/1.2)};
  }
  function formatRegistration(value){
    const reg=normalizeReg(value).replace(/[^A-Z0-9 ]/g,'');
    if(reg.includes(' '))return reg;
    for(const pattern of [/^([A-Z]{2}\d{2})([A-Z]{3})$/,/^([A-Z]\d{1,3})([A-Z]{3})$/,/^([A-Z]{3})(\d{1,3}[A-Z])$/,/^([A-Z]{1,3})(\d{1,4})$/,/^(\d{1,4})([A-Z]{1,3})$/]){
      const match=reg.match(pattern);if(match)return match[1]+' '+match[2];
    }
    return reg;
  }
  function bikeLines(value){
    const reg=formatRegistration(value);
    const chunks=reg.split(' ').filter(Boolean);
    if(chunks.length>1)return [chunks[0],chunks.slice(1).join('')];
    const split=Math.ceil(reg.length/2);
    return [reg.slice(0,split),reg.slice(split)];
  }
  function cartItem(state,products,registration,quantity,ack,ev){
    const s=normalizeState(state),selected=resolve(s,products);
    if(!selected.product?.live||!selected.variant?.available||!validReg(registration)||!Number.isInteger(quantity)||quantity<1||quantity>99||!ack||(s.badge.includes('ev')&&!ev))return null;
    const properties={
      Registration:normalizeReg(registration),
      Vehicle:s.vehicle==='car'?'Car — 520 mm × 111 mm':'Motorcycle — 9 × 7 inches',
      'Plate position':s.position==='pair'?'Front & rear pair':s.position==='front'?'Front — White':'Rear — Yellow',
      'Plate style':s.style==='2d'?'2D flat printed':'4D raised — '+s.thickness+' mm '+s.finish+' black',
      Border:s.border==='none'?'No border':'Black 3 mm',
      'UK side badge':badgeValues[s.badge],
      'Document check':'Required before dispatch',
      '_spritz_legal_plate':'true',
      'Registration and document requirements acknowledged':'Yes'
    };
    if(s.badge.includes('ev'))properties['Zero-emission vehicle']='Confirmed';
    return {id:selected.variant.id,quantity,properties};
  }
  const model={normalizeState,disabled,specification,resolve,price,validReg,formatRegistration,bikeLines,cartItem};
  if(typeof module!=='undefined'&&module.exports)module.exports=model;
  if(typeof document==='undefined')return;
  function init(scope=document){
    scope.querySelectorAll('[data-plate-configurator]').forEach(root=>{
      if(root.dataset.ready)return;
      const products=JSON.parse(root.querySelector('[data-configurator-products]').textContent),text=JSON.parse(root.querySelector('[data-configurator-text]').textContent);
      const form=root.querySelector('form'),reg=root.querySelector('[data-registration]'),qty=root.querySelector('[data-quantity]'),ack=root.querySelector('[data-ack]'),ev=root.querySelector('[data-ev]'),button=root.querySelector('[data-add]'),status=root.querySelector('[data-status]');
      const money=value=>new Intl.NumberFormat('en-GB',{style:'currency',currency:root.dataset.currency||'GBP'}).format(value/100);
      let state=normalizeState({style:root.dataset.defaultStyle,position:root.dataset.defaultPosition,vehicle:root.dataset.defaultVehicle}),carPosition=state.vehicle==='car'?state.position:'pair',busy=false,fontsReady=!document.fonts;
      const output=(selector,value)=>{root.querySelector(selector).textContent=value;};
      const label=(key,value)=>text[key==='style'?(value==='2d'?'flat':'raised'):key==='border'?(value==='none'?'no_border':'black_border'):key==='thickness'?'mm'+value:value]||value;
      function drawPreview(){
        let badgeFits=true,registrationFits=true;
        const bike=state.vehicle==='motorcycle',displayReg=formatRegistration(reg.value),lines=bikeLines(reg.value),hasBadge=state.badge!=='none',raised=state.style==='4d';
        root.querySelectorAll('[data-preview]').forEach(figure=>{
          const type=figure.dataset.preview;
          figure.hidden=bike?type!=='motorcycle':type==='motorcycle'||(state.position!=='pair'&&type!==state.position);
          const svg=figure.querySelector('svg.pc-plate-svg');
          svg.dataset.style=raised?'raised':'flat';svg.dataset.finish=state.finish;svg.style.setProperty('--pc-depth',raised?(Number(state.thickness)*.45)+'px':'0px');
          const border=svg.querySelector('[data-preview-border]');border.toggleAttribute('hidden',state.border==='none');
          const badge=svg.querySelector('[data-preview-badge]');badge.toggleAttribute('hidden',!hasBadge);badge.classList.toggle('pc-badge--ev',state.badge.includes('ev'));badge.classList.toggle('pc-badge--raised',state.badge.startsWith('raised'));
          const texts=svg.querySelectorAll('[data-preview-reg]');
          texts.forEach(node=>{
            const row=node.dataset.previewReg;
            node.textContent=row==='single'?displayReg:lines[row==='top'?0:1];
            node.setAttribute('x',String((type==='motorcycle'?114.3:260)+(hasBadge&&type!=='motorcycle'?18:0)));
            node.style.removeProperty('font-size');
          });

          if(!figure.hidden&&fontsReady){
            const widths=Array.from(texts,node=>Math.round(Math.max(0,node.getComputedTextLength()-(type==='motorcycle'?10:11))*10)/10);
            const width=Math.max(...widths);
            badgeFits=badgeFits&&(type==='motorcycle'?widths[0]<=206&&widths[1]<=158:width<=450);
            registrationFits=registrationFits&&width<=(type==='motorcycle'?206:488);
          }
          svg.setAttribute('aria-label',[text[type==='motorcycle'?'bike_caption':type+'_caption'],displayReg,label('style',state.style),label('border',state.border),label('badge',state.badge)].join(', '));
        });
        output('[data-preview-size]',text[bike?'bike_size':'car_size']);
        output('[data-preview-height]',text[bike?'bike_letter_height':'car_letter_height']);
        return {badgeFits,registrationFits};
      }
      function update(){
        state=normalizeState(state);
        root.querySelectorAll('input[type="radio"]').forEach(input=>{
          input.disabled=disabled(state,input.name,input.value);
          input.checked=state[input.name]===input.value;
        });
        const fit=drawPreview();
        root.querySelectorAll('input[name="badge"]').forEach(input=>{input.disabled=input.value!=='none'&&!fit.badgeFits;});
        if(!fit.badgeFits&&state.badge!=='none'){state.badge='none';update();return;}
        const fitNote=root.querySelector('[data-preview-fit]');
        fitNote.hidden=fit.badgeFits&&fit.registrationFits;
        fitNote.textContent=!fit.registrationFits?text.registration_fit:text.badge_fit;
        const green=state.badge.includes('ev');root.querySelector('[data-ev-wrap]').hidden=!green;ev.disabled=!green;ev.required=green;if(!green)ev.checked=false;
        const selected=resolve(state,products),quantity=Number(qty.value),totals=price(state,products,quantity,root.dataset.taxesIncluded==='true');
        const variantId=root.querySelector('[data-variant-id]');variantId.value=selected.variant?.id||'';variantId.disabled=!selected.product?.live;
        qty.setCustomValidity(Number.isInteger(quantity)&&quantity>=1&&quantity<=99?'':text.invalid_quantity);
        const pair=state.vehicle==='car'&&state.position==='pair';
        const badgeSupplement=state.vehicle==='car'&&pair?960:600;
        root.querySelectorAll('[data-badge-extra]').forEach(node=>{node.textContent=text.price_extra.replace('__price__',money(badgeSupplement));});
        output('[data-quantity-label]',text[pair?'pair_quantity':'single_quantity']);
        output('[data-summary-reg]',normalizeReg(reg.value)||text.blank_registration);
        output('[data-summary-description]',[label('vehicle',state.vehicle),label('position',state.position),label('style',state.style)+(state.style==='4d'?' · '+label('thickness',state.thickness)+' '+label('finish',state.finish):''),label('border',state.border),label('badge',state.badge)].join(' · '));
        for(const [selector,key] of [['[data-base-price]','base'],['[data-badge-price]','badge'],['[data-gross]','items'],['[data-delivery]','delivery'],['[data-total]','total'],['[data-review-total]','total'],['[data-net]','net']])output(selector,totals?money(totals[key]):'—');
        root.querySelector('[data-badge-price-row]').hidden=!totals?.badge;
        output('[data-badge-price-label]',text[pair?'badges_price':'badge_price']);
        output('[data-delivery-note]',text[state.vehicle==='car'?'shipping_car':'shipping_bike']);
        const enabled=root.dataset.enabled==='true'&&selected.product?.live;
        button.disabled=busy||!enabled||!selected.variant?.available||!totals||!fit.registrationFits;
        output('[data-launch-note]',enabled?(selected.variant?.available?'':text.not_available):text.draft);
      }
      root.addEventListener('change',event=>{
        const input=event.target;
        if(input.matches('input[type="radio"]')){
          if(input.name==='position'&&state.vehicle==='car')carPosition=input.value;
          if(input.name==='vehicle')state.position=input.value==='car'?carPosition:'rear';
          state[input.name]=input.value;
        }
        update();
      });
      root.addEventListener('input',event=>{
        if(event.target.matches('input[type="radio"]'))return;
        if(event.target===reg){reg.setCustomValidity(validReg(reg.value)?'':text.invalid_reg);ack.checked=false;}
        update();
      });
      reg.addEventListener('blur',()=>{reg.value=normalizeReg(reg.value);update();});
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(busy||root.dataset.enabled!=='true')return;
        reg.setCustomValidity(validReg(reg.value)?'':text.invalid_reg);update();
        if(!form.reportValidity()||button.disabled)return;
        const item=cartItem(state,products,reg.value,Number(qty.value),ack.checked,ev.checked);
        if(!item){status.textContent=text.not_available;return;}
        busy=true;update();button.textContent=text.adding;status.textContent='';
        try{
          const response=await fetch(form.action.replace(/\/add\/?$/,'/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||text.unavailable);
          status.textContent=text.success;root.querySelector('[data-basket-link]').hidden=false;window.location.assign(form.dataset.cartUrl);
        }catch(error){status.textContent=text.error;root.querySelector('[data-basket-link]').hidden=false;}
        finally{busy=false;button.textContent=text.add;update();}
      });
      update();root.dataset.ready='true';
      if(document.fonts){
        Promise.all([
          document.fonts.load('100px "Spritz Charles Wright"','AB12 CDE'),
          document.fonts.load('100px "Spritz Charles Wright Motorcycle"','AB12 CDE')
        ]).then(()=>{fontsReady=true;if(root.isConnected)update();}).catch(()=>{});
      }
    });
  }
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',event=>init(event.target));
  if(document.readyState!=='loading')init();
})();
